import { useUserStore } from "@/stores/useUserStore";
import { useCallback } from "react";
import { checkPermission } from "@/utils/permission";

/** 审核中心审批权限 key，拥有此权限的用户提交后会自动通过审核 */
const REVIEW_APPROVE_KEY = "/review_center/pending_approve";

/** 发布成功（自动通过审核）的 i18n key */
const PUBLISH_SUCCESS_I18N_KEY = "pages.common.publishSuccess";

/**
 * 权限校验 Hook
 */
export const useAccess = () => {
  const { userInfo } = useUserStore();

  const hasAccess = useCallback(
    (authKey?: string) => {
      // 如果没有传入 authKey，默认有权限
      if (!authKey) return true;
      // 检查菜单权限
      if (userInfo?.menus) {
        return checkPermission(userInfo.menus, authKey);
      }
      return false;
    },
    [userInfo],
  );

  /**
   * 获取"保存并发布"成功后的提示 i18n key。
   * - 如果用户拥有审核权限（能访问审核中心），后端自动通过审核 → 返回"发布成功"
   * - 否则返回传入的 fallback key（如"提交审核成功"等）
   * @param fallbackId 无审核权限时的回退 i18n key
   * @param isPublish 是否为发布操作，传 false 则跳过审核权限判断直接返回 fallbackId
   */
  const getPublishMessageId = useCallback(
    (fallbackId: string, isPublish = true) =>
      isPublish && hasAccess(REVIEW_APPROVE_KEY)
        ? PUBLISH_SUCCESS_I18N_KEY
        : fallbackId,
    [hasAccess],
  );

  return {
    hasAccess,
    getPublishMessageId,
    userInfo,
    isSuper: !!userInfo?.isSuper,
  };
};
